import { render, staticRenderFns } from "./BrowserHome.vue?vue&type=template&id=6d5974b6&scoped=true&"
import script from "./BrowserHome.vue?vue&type=script&lang=js&"
export * from "./BrowserHome.vue?vue&type=script&lang=js&"
import style0 from "./BrowserHome.vue?vue&type=style&index=0&id=6d5974b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5974b6",
  null
  
)

export default component.exports